export default __webpack_public_path__ + "static/media/flag-promo.abd3906d.svg";